import React, { type ComponentType } from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';
import type { ProductDependenciesProviderProps } from '@atlassian/company-hub-common/controllers/use-product-dependencies';
import type { HubExtensionsWrapperProps } from '@atlassian/company-hub-common/hub-extensions-wrapper';

import type { SpotlightParameters } from '../../../types';
import { Spotlight } from './spotlight';

export type SpotlightExtensionProps = HubExtensionsWrapperProps<SpotlightParameters> & {
	propsProvider: ComponentType<ProductDependenciesProviderProps>;
};

export const SpotlightExtension = ({
	contentId,
	extensionNode,
	propsProvider,
}: SpotlightExtensionProps): React.JSX.Element => {
	const { parameters = '' } = extensionNode || {};

	if (!parameters) {
		return <Box testId="no-params-empty-state" />;
	}

	return (
		<Spotlight extensionNode={extensionNode} contentId={contentId} PropsProvider={propsProvider} />
	);
};
